export default "__VITE_ASSET__B8Sie1Z5__";